"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VacatureDetail = function VacatureDetail(props) {
  var _useState = (0, _react.useState)({
    data: props.vacature
  }),
      _useState2 = _slicedToArray(_useState, 2),
      loadDetails = _useState2[0],
      setLoadDetails = _useState2[1];

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: "image__container" },
        _react2.default.createElement("img", { className: "image", src: loadDetails.data.image })
      ),
      _react2.default.createElement(
        "div",
        { className: "modal__content" },
        _react2.default.createElement(
          "h2",
          { className: "modal__title" },
          loadDetails.data.title
        ),
        _react2.default.createElement(
          "p",
          null,
          loadDetails.data.text
        )
      )
    )
  );
};

exports.default = VacatureDetail;